/* ==========================================================================
   LUNÉA COSMETICS — Winkelwagenlade: gedragslaag
   Vult de gaten in theme.js zonder dat bestand te wijzigen:
     · scroll-vergrendeling van de pagina zolang de lade open staat
     · sluiten met Escape + focus die netjes in en uit de lade beweegt
     · Nederlandse labels op knoppen die theme.js hard in het Engels invoegt
     · aantal met de hand intypen werkt nu ook (alleen +/- werkte)
     · teller in de header verbergen en afrekenknop blokkeren bij lege wagen
     · lege aanbevelingskolom verbergen
   Vanilla JS, geen afhankelijkheden. Faalt stil als de lade niet bestaat.
   ========================================================================== */
(function () {
  'use strict';

  /* Dit bestand hangt aan block-cart.liquid. Wordt dat snippet ooit twee keer
     gerenderd (twee headerlayouts, of een sectie die opnieuw laadt in de theme
     editor), dan zouden alle gedelegeerde listeners dubbel binden en zou elke
     aantalwijziging twee POSTs versturen. Deze vlag houdt dat tegen. */
  if (window.__luneaCartUI) return;
  window.__luneaCartUI = true;

  var root = document.querySelector('.js-mini-cart');
  if (!root) return;

  var panel     = root.querySelector('.mini-cart-content');
  var list      = root.querySelector('.js-mini-cart-content');
  var isDrawer  = root.classList.contains('cardraw');
  var lastFocus = null;

  function t(name, fallback) {
    return root.getAttribute('data-lu-' + name) || fallback;
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), ' +
                  'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* ----------------------------------------------------------------------
     1. Openen en sluiten
     -------------------------------------------------------------------- */
  function isOpen() { return root.classList.contains('active'); }

  function close() {
    root.classList.remove('active');
  }

  function setExpanded(state) {
    var toggle = root.querySelector('.js-toggle-cart');
    if (toggle) toggle.setAttribute('aria-expanded', state ? 'true' : 'false');
  }

  function onOpen() {
    document.body.classList.add('lu-cart-open');
    setExpanded(true);
    lastFocus = document.activeElement;
    var closeBtn = panel && panel.querySelector('.modal-header .close');
    if (closeBtn) {
      window.setTimeout(function () { closeBtn.focus(); }, 60);
    }
  }

  function onClose() {
    document.body.classList.remove('lu-cart-open');
    setExpanded(false);
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus();
      lastFocus = null;
    }
    // Openstaande subpanelen opruimen zodat de lade schoon heropent
    Array.prototype.forEach.call(
      root.querySelectorAll('.block-addon__box--wrap.active, .js-note-cart.active, .boxgift.active'),
      function (el) { el.classList.remove('active'); }
    );
    if (panel) panel.classList.remove('overlay');
  }

  if (isDrawer && panel) {
    new MutationObserver(function () {
      if (isOpen()) { onOpen(); } else { onClose(); }
    }).observe(root, { attributes: true, attributeFilter: ['class'] });

    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;

      if (e.key === 'Escape' || e.keyCode === 27) {
        e.preventDefault();
        close();
        return;
      }

      if (e.key !== 'Tab' && e.keyCode !== 9) return;

      var items = Array.prototype.filter.call(
        panel.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null; }
      );
      if (!items.length) return;

      var first = items[0];
      var last  = items[items.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      } else if (!panel.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  /* ----------------------------------------------------------------------
     2. Labels vertalen die theme.js hard invoegt
     -------------------------------------------------------------------- */
  var LABEL_REMOVE   = t('remove', 'Verwijderen');
  var LABEL_DECREASE = t('decrease', 'Aantal verlagen');
  var LABEL_INCREASE = t('increase', 'Aantal verhogen');
  var LABEL_QUANTITY = t('quantity', 'Aantal');

  function relabel() {
    if (!list) return;

    Array.prototype.forEach.call(list.querySelectorAll('.js-remove-mini-cart'), function (btn) {
      if (btn.textContent.trim() !== LABEL_REMOVE) btn.textContent = LABEL_REMOVE;
    });
    Array.prototype.forEach.call(list.querySelectorAll('.js-qty__minus'), function (btn) {
      btn.setAttribute('aria-label', LABEL_DECREASE);
    });
    Array.prototype.forEach.call(list.querySelectorAll('.js-qty__plus'), function (btn) {
      btn.setAttribute('aria-label', LABEL_INCREASE);
    });
    Array.prototype.forEach.call(list.querySelectorAll('.js-qty__input'), function (input) {
      input.setAttribute('aria-label', LABEL_QUANTITY);
      input.setAttribute('inputmode', 'numeric');
    });
  }

  /* ----------------------------------------------------------------------
     3. Aantal met de hand intypen
     -------------------------------------------------------------------- */
  function refresh(attempt) {
    if (window.theme && window.theme.miniCart) {
      window.theme.miniCart.updateElements();
      window.theme.miniCart.generateCart();
      return;
    }

    /* theme.js is nog niet klaar met parsen. Even wachten is beter dan de
       hele pagina herladen: dat gooide de winkelwagenlade dicht en kostte
       de bezoeker zijn plek in de pagina. */
    var tries = attempt || 0;
    if (tries < 40) {
      window.setTimeout(function () { refresh(tries + 1); }, 50);
    }
  }

  function commitQuantity(input) {
    var line = parseInt(input.getAttribute('data-line'), 10);
    var qty  = parseInt(String(input.value).replace(/[^0-9]/g, ''), 10);

    if (!line || isNaN(qty) || qty < 0) {
      refresh();
      return;
    }
    if (String(qty) === input.getAttribute('data-lu-current')) return;
    input.setAttribute('data-lu-current', String(qty));

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart/change.js'
            : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function () { refresh(); })
      .catch(function () { refresh(); });
  }



  document.addEventListener('change', function (e) {
    var input = e.target.closest ? e.target.closest('.change-minicart') : null;
    if (input) commitQuantity(input);
  });



  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.keyCode !== 13) return;
    var input = e.target.closest ? e.target.closest('.change-minicart') : null;
    if (input) {
      e.preventDefault();
      commitQuantity(input);
    }
  });

  /* ----------------------------------------------------------------------
     4. Winkelwagenpagina: mobiel en desktop tonen dezelfde regel twee keer.
        Beide invoervelden gelijk houden, anders stuurt "Winkelwagen
        bijwerken" de waarde van het onzichtbare veld mee.
     -------------------------------------------------------------------- */
  document.addEventListener('input', function (e) {
    var field = e.target.closest ? e.target.closest('[data-cart-key]') : null;
    if (!field) return;
    var key = field.getAttribute('data-cart-key');
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-cart-key="' + key + '"]'),
      function (twin) { if (twin !== field) twin.value = field.value; }
    );
  });

  /* ----------------------------------------------------------------------
     5. Lege staten
     -------------------------------------------------------------------- */
  function syncEmptyState() {
    var counter = root.querySelector('.js-cart-count');
    var count   = counter ? parseInt(counter.textContent.replace(/[^0-9]/g, ''), 10) : 0;
    var empty   = !count || isNaN(count);

    root.classList.toggle('is-empty', empty);

    var checkout = root.querySelector('.js-cart-btn-checkout');
    if (checkout) {
      checkout.classList.toggle('disabled', empty);
      checkout.setAttribute('aria-disabled', empty ? 'true' : 'false');
      if (empty) {
        checkout.setAttribute('tabindex', '-1');
      } else {
        checkout.removeAttribute('tabindex');
      }
    }
  }

  var crossell = root.querySelector('.drawer-crossell');
  if (crossell && !crossell.querySelector('.drawer-crossell__item')) {
    crossell.classList.add('is-empty');
  }

  /* ----------------------------------------------------------------------
     6. Aanhaken op elke herbouw van de lade
     -------------------------------------------------------------------- */
  function sync() {
    relabel();
    syncEmptyState();
  }

  if (list) {
    new MutationObserver(sync).observe(list, { childList: true, subtree: true });
  }
  var counterEl = root.querySelector('.js-cart-count');
  if (counterEl) {
    new MutationObserver(syncEmptyState).observe(counterEl, { childList: true, characterData: true, subtree: true });
  }

  sync();
  window.setTimeout(sync, 600);
})();
